module.exports = __webpack_public_path__ + "static/media/furia-race.e31ed262.svg";